<script>
import axios from '@/utils/axios';
import HrmLeaveApplyModal from '@/components/modal/hrm-leave-apply-modal.vue';
// ✅ A) NEW IMPORT
import HrmTeamRequests from '@/views/pages/hrms/hrm-team-requests.vue';

const SESSION_LABELS = {
  full_day: 'Full Day',
  half_day_morning: 'Half Day (AM)',
  half_day_afternoon: 'Half Day (PM)',
  short_day_morning: 'Short Day (AM)',
  short_day_afternoon: 'Short Day (PM)',
};

export default {
  // ✅ B) UPDATED COMPONENTS
  components: { HrmLeaveApplyModal, HrmTeamRequests },
  inject: ['setLoading'],
  data() {
    return {
      // ✅ C) activeTab ADDED
      activeTab: 'my',
      loadingBalances: true,
      loading: true,
      balances: [],
      requests: [],
      statusFilter: '',
      statusOptions: ['pending', 'approved', 'rejected', 'cancelled'],
      tableColumns: [
        { key: 'leave_type', label: 'Leave Type' },
        { key: 'dates', label: 'Dates' },
        { key: 'total_days', label: 'Days' },
        { key: 'session', label: 'Session' },
        { key: 'status', label: 'Status' },
        { key: 'reason', label: 'Reason' },
        { key: 'actions', label: '', width: '60px' },
      ],
      pagination: { current_page: 1, per_page: 20, last_page: 1, total: 0, links: [] },
      cancelItem: null,
    };
  },
 
  computed: {
        isManager() {
        try {
            const u = JSON.parse(localStorage.getItem('auth_user')) || {};
            return u.is_manager === true || u.employee?.is_manager === true;
        } catch { return false; }
        },
  },
  mounted() {
    this.fetchBalances();
    this.fetchRequests();
  },
  methods: {

    ringDash(b) {
      const C = 2 * Math.PI * 52;
      const total = Number(b.allocated) || 0;
      const remaining = Number(b.remaining) || 0;
      const pct = total > 0 ? Math.min(Math.max(remaining / total, 0), 1) : 0;
      return `${(pct * C).toFixed(1)} ${C.toFixed(1)}`;
    },


    async fetchBalances() {
      this.loadingBalances = true;
      try {
        const res = await axios.get('/hrms/leaves/my-balances');
        this.balances = res.data.data || [];
      } catch (e) { this.$swalToast(e.message, 'error'); }
      finally { this.loadingBalances = false; }
    },
    async fetchRequests(page = 1) {
      this.loading = true;
      try {
        const res = await axios.get('/hrms/leaves/my-requests', {
          params: { page, status: this.statusFilter || undefined },
        });
        const d = res.data.data;
        this.requests = d.data;
        this.pagination = { current_page: d.current_page, per_page: d.per_page, last_page: d.last_page, total: d.total, links: d.links };
      } catch (e) { this.$swalToast(e.message, 'error'); }
      finally { this.loading = false; }
    },
    openApply() { this.$refs.applyModal.open(); },
    onUpdated() { this.fetchBalances(); this.fetchRequests(1); },
    sessionLabel(s) { return SESSION_LABELS[s] || s; },
    cardColor(c) { return c || '#6366f1'; },
    confirmCancel(row) { this.cancelItem = row; this.$openModal('hrm_leave_cancel_modal'); },
    async cancelRequest() {
      this.setLoading(true);
      try {
        const res = await axios.patch(`/hrms/leaves/${this.cancelItem.id}/cancel`);
        this.$swalToast(res.data.message || 'Request cancelled.');
        this.$closeModal('hrm_leave_cancel_modal');
        this.onUpdated();
      } catch (e) { this.$swalToast(e.message, 'error'); }
      finally { this.setLoading(false); }
    },
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- ✅ E) HEADER UPDATED — title "Leave", Apply sirf My tab pe, + tabs -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <h4 class="page-title mb-0">Leave</h4>
        <a v-if="activeTab === 'my'" href="javascript:void(0);" class="btn btn-primary d-flex align-items-center" @click="openApply">
          <i class="ti ti-circle-plus me-2"></i>Apply Leave
        </a>
      </div>

      <!-- Tabs (sirf manager ko dikhenge) -->
      <ul v-if="isManager" class="lv-tabs mb-3">
        <li :class="{ active: activeTab === 'my' }" @click="activeTab = 'my'">My Leave</li>
        <li :class="{ active: activeTab === 'team' }" @click="activeTab = 'team'">Team Requests</li>
      </ul>

      <!-- ✅ F) MY LEAVE TAB WRAPPER START -->
      <div v-show="activeTab === 'my'">

        <!-- Balances -->
        <div v-if="loadingBalances" class="lv-state"><div class="spinner-border text-primary"></div></div>
        <div v-else-if="!balances.length" class="lv-state">
          <i class="ti ti-wallet d-block mb-2" style="font-size:34px; opacity:.35;"></i>
          No leave balance allocated yet.
        </div>
        <div v-else class="row g-3 mb-2">
                <div v-for="(b, i) in balances" :key="i" class="col-xxl-3 col-md-4 col-sm-6">
                <div class="lv-ring-card">
                    <div class="lv-ring-wrap">
                    <svg viewBox="0 0 120 120" class="lv-ring">
                        <circle cx="60" cy="60" r="52" class="lv-ring-track"></circle>
                        <circle cx="60" cy="60" r="52" class="lv-ring-fill"
                        :stroke="cardColor(b.color)"
                        :stroke-dasharray="ringDash(b)"
                        stroke-linecap="round"
                        transform="rotate(-90 60 60)"></circle>
                    </svg>
                    <div class="lv-ring-center">
                        <span class="lv-ring-num" :style="{ color: cardColor(b.color) }">{{ b.remaining }}</span>
                        <span class="lv-ring-unit">days left</span>
                    </div>
                    </div>
                    <div class="lv-ring-label">{{ b.leave_type }}</div>
                    <div class="lv-ring-meta">
                    <span>Total {{ b.allocated }}</span>
                    <span class="lv-sep">•</span>
                    <span>Used {{ b.used }}</span>
                    <template v-if="b.carried_forward">
                        <span class="lv-sep">•</span>
                        <span>CF {{ b.carried_forward }}</span>
                    </template>
                    </div>
                </div>
                </div>
            </div>

        <!-- Requests -->
        <div class="card border-0 shadow-sm mb-0" style="border-radius:14px;">
          <div class="card-header bg-white border-bottom d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
            <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
              My Requests <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{ pagination.total }})</span>
            </h5>
            <select class="form-select form-select-sm" style="width:auto; min-width:140px;" v-model="statusFilter" @change="fetchRequests(1)">
              <option value="">All Status</option>
              <option v-for="s in statusOptions" :key="s" :value="s">{{ s.charAt(0).toUpperCase() + s.slice(1) }}</option>
            </select>
          </div>

          <div class="card-body px-3 pt-2 pb-3" style="background:#f1f5f9;">
            <app-table
              :columns="tableColumns" :rows="requests" :pagination="pagination" :loading="loading"
              empty-text="No leave requests yet." empty-icon="ti ti-calendar-off"
              @page-change="fetchRequests"
            >
              <template #leave_type="{ row }">
                <span class="lv-dot" :style="{ background: cardColor(row.leave_type?.color) }"></span>
                {{ row.leave_type?.name || '-' }}
                </template>
              <template #dates="{ row }">
                <span v-if="row.from_date === row.to_date">{{ $formatDate(row.from_date) }}</span>
                <span v-else>{{ $formatDate(row.from_date) }} – {{ $formatDate(row.to_date) }}</span>
              </template>
              <template #total_days="{ row }">{{ row.total_days }}</template>
              <template #session="{ row }">
                <span style="font-size:11.5px; color:#64748b;">{{ sessionLabel(row.session) }}</span>
              </template>
              <template #status="{ row }">
                <span class="lv-st" :class="'lv-' + row.status">{{ row.status }}</span>
              </template>
              <template #reason="{ row }">
                <span style="font-size:12px; color:#64748b;">{{ row.reason || '-' }}</span>
              </template>
              <template #actions="{ row }">
                <button v-if="row.status === 'pending'" class="btn btn-sm btn-light text-danger" title="Cancel" @click="confirmCancel(row)">
                  <i class="ti ti-x"></i>
                </button>
                <span v-else>-</span>
              </template>
            </app-table>
          </div>
        </div>

      </div>
      <!-- ✅ F) MY LEAVE TAB WRAPPER END -->

      <!-- ✅ F) TEAM REQUESTS TAB -->
      <hrm-team-requests v-if="isManager && activeTab === 'team'" />

    </div>
    <app-footer></app-footer>
  </div>

  <!-- Apply offcanvas -->
  <hrm-leave-apply-modal ref="applyModal" @updated="onUpdated" />

  <!-- Cancel confirm -->
  <div class="modal fade" id="hrm_leave_cancel_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3"><i class="ti ti-calendar-x fs-36"></i></span>
          <h4 class="mb-1">Cancel Request</h4>
          <p class="mb-3">Cancel this pending leave request? This can't be undone.</p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">No</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="cancelRequest">Yes, Cancel</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.lv-state { text-align: center; padding: 40px 20px; color: #94a3b8; font-size: 13.5px; background: #fff; border-radius: 14px; margin-bottom: 12px; }
.lv-bal { background: #fff; border: 1px solid #eef2f7; border-left: 4px solid var(--c); border-radius: 12px; padding: 14px 16px; height: 100%; box-shadow: 0 1px 2px rgba(15,23,42,.04); }
.lv-bal-top { display: flex; align-items: center; justify-content: space-between; }
.lv-bal-name { font-size: 13px; font-weight: 700; color: #1e293b; }
.lv-bal-code { font-size: 10px; font-weight: 700; color: #94a3b8; }
.lv-bal-remain { font-size: 26px; font-weight: 800; color: var(--c); margin: 6px 0 8px; line-height: 1; }
.lv-bal-remain small { font-size: 11px; font-weight: 600; color: #94a3b8; }
.lv-bal-meta { display: flex; gap: 12px; flex-wrap: wrap; font-size: 11px; color: #64748b; }
.lv-bal-meta b { color: #334155; }
.lv-dot { display: inline-block; width: 9px; height: 9px; border-radius: 50%; margin-right: 6px; vertical-align: middle; }
.lv-st { display: inline-block; font-size: 10px; font-weight: 600; padding: 3px 10px; border-radius: 20px; text-transform: capitalize; }
.lv-pending { background: #fef3c7; color: #b45309; }
.lv-approved { background: #dcfce7; color: #16a34a; }
.lv-rejected { background: #fee2e2; color: #dc2626; }
.lv-cancelled { background: #f1f5f9; color: #94a3b8; }
/* ✅ G) TAB STYLES ADDED */
.lv-tabs { display: flex; gap: 6px; list-style: none; padding: 4px; margin: 0; background: #fff; border-radius: 12px; width: fit-content; box-shadow: 0 1px 2px rgba(15,23,42,.04); }
.lv-tabs li { font-size: 13px; font-weight: 600; color: #64748b; padding: 8px 18px; border-radius: 9px; cursor: pointer; transition: all .15s; }
.lv-tabs li:hover { color: #4f46e5; }
.lv-tabs li.active { background: linear-gradient(135deg, #4f46e5, #7c3aed); color: #fff; }

.lv-ring-card { background:#fff; border:1px solid #eef2f7; border-radius:16px; padding:18px 16px 16px; text-align:center; box-shadow:0 1px 2px rgba(15,23,42,.04); height:100%; }
.lv-ring-wrap { position:relative; width:120px; height:120px; margin:0 auto 12px; }
.lv-ring { width:120px; height:120px; }
.lv-ring-track { fill:none; stroke:#eef2f7; stroke-width:10; }
.lv-ring-fill { fill:none; stroke-width:10; transition:stroke-dasharray .6s ease; }
.lv-ring-center { position:absolute; inset:0; display:flex; flex-direction:column; align-items:center; justify-content:center; }
.lv-ring-num { font-size:30px; font-weight:800; line-height:1; }
.lv-ring-unit { font-size:10.5px; font-weight:600; color:#94a3b8; margin-top:3px; }
.lv-ring-label { font-size:13.5px; font-weight:700; color:#1e293b; }
.lv-ring-meta { font-size:11px; color:#64748b; margin-top:4px; display:flex; gap:6px; justify-content:center; flex-wrap:wrap; }
.lv-sep { color:#cbd5e1; }
</style>